import React from 'react';

export const EmployeeContext = React.createContext(null);